import React, { Fragment, useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import AddPersonalDetails from "./AddPersonalDetails";
import AddHouseHold from "./AddHouseHold";
import DocumentList from "../DocumentList";
import { useDispatch, useSelector } from "react-redux";
import AddEmergencyContact from "./AddEmergencyContact";
import { useLocation, useNavigate } from "react-router";
import AddPatientPortal from "./AddPatientPortal";
import AddApplications from "./AddApplications";
import AddInsurance from "./AddInsurance";

function AddPatient() {
  const [documentList, setDocumentList] = useState([]);
  const location = useLocation();
  const tab = location?.state?.activeTab;
  const [activeTab, setActiveTab] = useState(tab ? tab :"1"); // Define activeTab in state
  const data = location?.state?.patientDetails;
  const [patientDeatils, setPatientDetails]= useState(data ? data : {});
  const [isPatientUpdated, setIsPatientUpdated]= useState(false);
  const dispatch = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  const [isPatientCreated, setIsPatientCreated] = useState(data ? true : false);
  const userRole = localStorage.getItem('userRole');

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Fragment>
      <div className="add_patient_container">
        <h2>{!patientDeatils?._id ? "Create New Patient": "Edit Patient"}</h2>
        <div className="add_patient_form">
          <div className="add_block">
            <div className="tab_blk">
              <div>
                <Nav tabs className="profile_intab horizontal-scroll">
                  <NavItem>
                    <NavLink
                      className={activeTab === "1" ? "active" : ""}
                      onClick={() => toggleTab("1")}
                    >
                      Personal
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "2" ? "active" : ""}
                      onClick={() => toggleTab("2")}
                      disabled={!isPatientCreated}
                    >
                      Household
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "3" ? "active" : ""}
                      onClick={() => toggleTab("3")}
                      disabled={!isPatientCreated}
                    >
                      Documents
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "4" ? "active" : ""}
                      onClick={() => toggleTab("4")}
                      disabled={!isPatientCreated}
                    >
                      Contact
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "5" ? "active" : ""}
                      onClick={() => toggleTab("5")}
                      disabled={!isPatientCreated}
                    >
                      Insurance
                    </NavLink>
                  </NavItem>
                  {userRole !== 'Patient' && (
                  <NavItem>
                    <NavLink
                      className={activeTab === "6" ? "active" : ""}
                      onClick={() => toggleTab("6")}
                      disabled={!isPatientCreated}
                    >
                      Portal
                    </NavLink>
                  </NavItem>
                  )}
                  {/* <NavItem>
                    <NavLink
                      className={activeTab === "7" ? "active" : ""}
                      onClick={() => toggleTab("7")}
                      disabled={!isPatientCreated}
                    >
                      Applications
                    </NavLink>
                  </NavItem> */}
                </Nav>
              </div>
            </div>
          </div>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="first_tab">
              <AddPersonalDetails toggleTab={toggleTab} setIsPatientCreated={setIsPatientCreated} setPatientDetails={setPatientDetails} patientDeatils={patientDeatils}/>
            </TabPane>
            <TabPane tabId="2">
              <AddHouseHold patientDeatils={patientDeatils} toggleTab={toggleTab}/>
            </TabPane>
            <TabPane tabId="3" className="second_tab">
              <DocumentList patientDeatils={patientDeatils} documentList={documentList} toggleTab={toggleTab}/>
            </TabPane>
            <TabPane tabId="4" className="first_tab">
              <AddEmergencyContact toggleTab={toggleTab} patientDeatils={patientDeatils}/>
            </TabPane>
            <TabPane tabId="5" className="first_tab">
              <AddInsurance toggleTab={toggleTab} patientDeatils={patientDeatils}/>
            </TabPane>
            <TabPane tabId="6" className="first_tab">
              <AddPatientPortal toggleTab={toggleTab} patientDeatils={patientDeatils}/>
            </TabPane>
            <TabPane tabId="7">
              {/* <AddApplications patientDeatils={patientDeatils}/> */}
              <AddPersonalDetails toggleTab={toggleTab} setIsPatientCreated={setIsPatientCreated} setPatientDetails={setPatientDetails} patientDeatils={patientDeatils}/>
            </TabPane>
            <TabPane tabId="9">
              <h4>Tab 9 Contents</h4>
            </TabPane>
            <TabPane tabId="10">
              <AddPersonalDetails toggleTab={toggleTab} setIsPatientCreated={setIsPatientCreated} setPatientDetails={setPatientDetails} patientDeatils={patientDeatils}/>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Fragment>
  );
}

export default AddPatient;
